module.exports = __webpack_public_path__ + "img/visawhite.7ef85eac.svg";